(ns rlws.iot-cloud.frontend.customers
  (:require [re-frame.core :as rf]
            [reagent.core :as r]
            [rlws.iot-cloud.frontend.assets :as assets]
            [rlws.iot-cloud.frontend.events :as events]
            [rlws.iot-cloud.frontend.openapi :as openapi]
            [rlws.iot-cloud.frontend.common :as common]
            [rlws.iot-cloud.frontend.navigation :as navigation]
            [rlws.iot-cloud.frontend.site :as site]
            [rlws.iot-cloud.frontend.subscriptions :as sub]
            [rlws.iot-cloud.frontend.uikit.table :as table]
            [rlws.iot-cloud.frontend.components :as components]
            [clojure.string :as str]))

(defn customers-table [customers]
  {:columns  [{:column-name "Name"
               :column-key  :name
               :render-fn   (fn [row]
                              (:name row))}
              {:column-key  :dealership
               :column-name "Dealership"
               :render-fn   (fn [_ dealership]
                              [:span (:name dealership)])}
              {:column-key  :location
               :column-name "Location"}
              {:column-key  :main-contact
               :column-name "Main Contact"}
              {:column-key  :phone
               :column-name "Phone Number"}
              {:column-key  :assets
               :column-name "Assets"
               :render-only #{:sort :filter}
               :render-fn   (fn [row href]
                              [:span.font-bold.text-decoration-none.color-secondary
                               "View Assets"])}]
   :filters  [{:label      "Dealership"
               :column-key :dealership}
              {:label      "Location"
               :column-key :location}
              {:label      "Main Contact"
               :column-key :main-contact}]
   :row-link {:href (fn [customer] 
                      (navigation/id-route
                       :customer
                       {:customer (site/to-plain-id customer)}))}
   :rows     customers
   :sort {:name :asc}})

(defn sites-table [sites]
  {:columns  [{:column-name "Name"
               :column-key  :name
               :render-fn   (fn [row]
                              (:name row))} 
              {:column-key  :location
               :column-name "Location"}
              {:column-key  :main-contact
               :column-name "Contact"}
              {:column-key :email
               :column-name "Email"}
              {:column-key  :phone
               :column-name "Phone Number"}
              {:column-key  :assets
               :column-name "Assets"
               :render-only #{:sort :filter}
               :render-fn   (fn [row href]
                              [:span.font-bold.text-decoration-none.color-secondary
                               "View Assets"])}]
   :filters  [{:label      "Location"
               :column-key :location}]
   :row-link {:href (fn [site] 
                      (navigation/id-route
                       :site
                       {:site (site/to-plain-id site)}))}
   :rows     sites
   :sort {:name :asc}})

(defn tab-header [tab]
  [:div {:style
         {:display "flex",
          :flex-direction "row"
          :margin-bottom "20px"}}
   [:button
    {:class (if (= tab :sites) "customer__header-button-selected" "customer__header-button")
     :type "button"
     :on-click (fn []
                 (rf/dispatch [::events/set-customer-tab :sites]))}
    [:span "Sites"]] 
   [:button
    {:class (if (= tab :customer-info) "customer__header-button-selected" "customer__header-button")
     :type "button"
     :on-click (fn []
                 (rf/dispatch [::events/set-customer-tab :customer-info]))}
    [:span "Customer Info"]]])

(def submitting? (r/atom false))

(defn one-customer-display
  []
  (let [{:keys [path-params]} @(rf/subscribe [::sub/current-route])
        current-user @(rf/subscribe [::sub/current-user])
        tabs @(rf/subscribe [::sub/customer-tab]) 
        site-dialog @(rf/subscribe [::sub/dialog])
        customer @(rf/subscribe [::sub/data :customer])
        customers @(rf/subscribe [::sub/complete-customers])
        sites @(rf/subscribe [::sub/complete-sites (site/to-plain-id customer)]) 
        assets @(rf/subscribe [::sub/customer-assets (site/to-plain-id customer)])]
    (if (= (site/to-plain-id customer) (:customer path-params))
      (if (= tabs :sites) 
        [:div
         (tab-header tabs)
         [:button
          {:class "customer__add-site-button"
           :on-click (fn []
                       (rf/dispatch [::events/set-dialog :site]))}
          
          [:span "+ Add Site"]]
         (when (= site-dialog :close)
           (reset! submitting? false)) 
         (when (= site-dialog :site)
           [:div 
            [:div.outside-modal
             {:on-click (fn []
                          (rf/dispatch [::events/set-dialog :close]))}]
            [:div
             {:style {:position        "fixed"
                      :top             "50%"
                      :left            "50%"
                      :border          "1px solid black"
                      :borderRadius    "5px"
                      :transform       "translate(-50%, -50%)"
                      :backgroundColor "white"
                      :zIndex          "100"
                      :padding         "20px"}}
             (let [state (r/atom nil)
                   openapi      (rf/subscribe [::sub/data :openapi]) 
                   current-user (rf/subscribe [::sub/current-user])
                   dealerships  (rf/subscribe [::sub/data :dealerships])
                   form-state   state] 
               [:div {}
                [:h1 {:class "customer__sub-heading"} "New Site"]
                (let [superuser? (contains? (:roles @current-user) "superuser")]
                  [:<>
                   [:div {:style {:display         "flex"
                                  :flex-direction  "row"
                                  :justify-content "space-between"}}
                    [:div
                     {:style {:flex-grow 1}}
                     (if openapi
                       [openapi/form
                        {:openapi          @openapi
                         :schema-name      "Site"
                         :form-data        @form-state
                         :remap-properties {"dealership" (when superuser?
                                                           #(openapi/create-enum % @dealerships))}
                         :on-submit        (fn [data]
                                             (rf/dispatch
                                              [::events/put-data
                                               (str "/api/sites/" (random-uuid))
                                               (cond-> data 
                                                 true (assoc :customer (site/to-plain-id customer))
                                                 true (assoc :dealership (:dealership customer))
                                                 (nil? (:email data)) (dissoc :email)
                                                 (nil? (:phone data)) (dissoc :phone)
                                                 (nil? (:main-contact data)) (dissoc :main-contact))
                                               [::events/modify-object-success "Added" :sites]])
                                             (reset! submitting? true))}
                        [:div {:style {:display         "flex"
                                       :justify-content "center"
                                       :paddingLeft     "20px"
                                       :paddingRight    "20px"
                                       :margin-top      "15px"
                                       :align-items     "center"
                                       :align-content   "center"}} 
                         [:button
                          {:class "customer__cancel-button"
                           :type "button"
                           :on-click (fn []
                                       (rf/dispatch [::events/set-dialog :close]))}
                          [:span "Cancel"]]
                         [:button
                          {:class "customer__save-button"
                           :type :submit
                           :disabled @submitting?}
                          (if @submitting?
                            [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                            [:span "Save"])]]]
                       [:p "Loading..."])]]])])
             [:div {:style {:display         "flex"
                            :justify-content "center"
                            :paddingLeft     "40px"
                            :paddingRight    "40px"
                            :align-items     "center"
                            :align-content   "center"
                            :margin-top       "20px"}}]]])
         [table/table (sites-table sites)]]
        (if (= tabs :assets)
          [:div
           (tab-header tabs)
           [:div
            [table/table
             (assets/customer-asset-table assets)]]]
          (if (= tabs :customer-info)
            [:div 
             (tab-header tabs)
             [:div.details-sidebar
              [:div.details-sidebar__container
               [:div.summary-details
                (for [{:keys [label value icon]}
                      [{:label "Name"
                        :value (:name customer)
                        :icon  "fa-building"}
                       {:label "Main Contact"
                        :value (:main-contact customer)
                        :icon  "fa-user"}
                       {:label "Email"
                        :value (:email customer)
                        :icon  "fa-at"}
                       {:label "Location"
                        :value (:location customer)
                        :icon  "fa-map-marked-alt"}
                       {:label "Phone Number"
                        :value (:phone customer)
                        :icon  "fa-phone"}]
                      :when value]
                  ^{:key (str label value)}
                  [:div.summary-details__group
                   (when-let [icon (get common/icons icon icon)]
                     [:div.summary-details__icon
                      [:i.fas {:class icon}]])
                   [:div
                    [:div.summary-details__label (str label)]
                    [:div.summary-details__value (str value)]]])]]]])))
      [:div.center
       [components/loader]])))

(defn all-customers
  []
  (let [checkbox (r/atom nil)]
    (fn []
      (rf/dispatch [::events/set-customer-tab :sites]) 
      (let [page-title @(rf/subscribe [::sub/page-title])
            customer-dialog @(rf/subscribe [::sub/dialog])
            customers @(rf/subscribe [::sub/complete-customers])
            current-user @(rf/subscribe [::sub/current-user])]
        [:<>
        ;;  [:div {:style {:float "right"}} 
        ;;   (when (contains? (:permissions current-user) :modify-customers) 
        ;;     [:button
        ;;      {:class "customer__add-button"
        ;;       :on-click (fn []
        ;;                   (rf/dispatch [::events/set-dialog :customer]))}
              
        ;;      [:span "+ Add Customer"]])] 
         (when (= customer-dialog :close)
           (reset! submitting? false))
         (when (= customer-dialog :customer)
           [:div
            [:div.outside-modal
             {:on-click (fn []
                          (rf/dispatch [::events/set-dialog :close]))}]
            [:div
             {:style {:position        "fixed"
                      :top             "50%"
                      :left            "50%"
                      :border          "1px solid black"
                      :borderRadius    "5px"
                      :transform       "translate(-50%, -50%)"
                      :backgroundColor "white"
                      :zIndex          "100"
                      :padding         "20px"}}
             (let [state (r/atom nil)
                   openapi      (rf/subscribe [::sub/data :openapi])
                   current-user (rf/subscribe [::sub/current-user])
                   dealerships  (rf/subscribe [::sub/data :dealerships])
                   form-state   state]

               [:div {}
                [:h1 {:class "customer__sub-heading"} "New Customer"]
                (let [superuser? (contains? (:roles @current-user) "superuser")]
                  [:<>
                   [:div {:style {:display         "flex"
                                  :flex-direction  "row"
                                  :justify-content "space-between"}}
                    [:div
                     {:style {:flex-grow 1}}
                     (if openapi
                       [openapi/form
                        {:openapi          @openapi
                         :schema-name      "Customer"
                         :form-data        @form-state
                         :remap-properties {"dealership" (when superuser?
                                                           #(openapi/create-enum % @dealerships))}
                         :on-submit        (fn [data]
                                             (rf/dispatch
                                              [::events/put-data
                                               (str "/api/customers/" (random-uuid))
                                               (cond-> data
                                                 (not superuser?) (assoc :dealership (:dealership @current-user)))
                                               [::events/modify-object-success "Added" :customers]])
                                             (reset! submitting? true))}
                        [:div {:style {:display         "flex"
                                       :justify-content "center"
                                       :paddingLeft     "20px"
                                       :paddingRight    "20px"
                                       :align-items     "center"
                                       :align-content   "center"
                                       :margin-top      "15px"}}
                         [:button
                          {:class "customer__cancel-button"
                           :type "button"
                           :on-click (fn []
                                       (rf/dispatch [::events/set-dialog :close]))}
                          [:span "Cancel"]]
                         [:button
                          {:class "customer__save-button"
                           :type :submit
                           :disabled @submitting?}
                          (if @submitting?
                            [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                            [:span "Save"])]]]
                       [:p "Loading..."])]]])])
             [:div {:style {:display         "flex"
                            :justify-content "center"
                            :paddingLeft     "40px"
                            :paddingRight    "40px"
                            :align-items     "center"
                            :align-content   "center"
                            :margin-top       "20px"}}]]])
         [table/table (customers-table customers)]]))))

(defn one-customer
  []
  (let [current-user @(rf/subscribe [::sub/current-user])
        customer @(rf/subscribe [::sub/data :customer])
        sites @(rf/subscribe [::sub/complete-sites (site/to-plain-id customer)])
        assets @(rf/subscribe [::sub/complete-assets (site/to-plain-id customer)])] 
    [:<>
     (rf/dispatch [::events/set-site-tab :site-assets])
     [:div 
      (one-customer-display)]]))

(defn site-asset [customer site assets]
  (let [asset-dialog @(rf/subscribe [::sub/dialog])]
    [:div
     (when (= asset-dialog :close)
       (reset! submitting? false))
     (when (= asset-dialog :asset)
       [:div
        [:div.outside-modal
         {:on-click (fn []
                      (rf/dispatch [::events/set-dialog :close]))}]
        [:div
         {:style {:position        "fixed"
                  :top             "50%"
                  :left            "50%"
                  :border          "1px solid black"
                  :borderRadius    "5px"
                  :transform       "translate(-50%, -50%)"
                  :backgroundColor "white"
                  :zIndex          "100"
                  :padding         "20px"}}
         (let [state (r/atom nil)
               openapi      (rf/subscribe [::sub/data :openapi])
               current-user (rf/subscribe [::sub/current-user])
               dealerships  (rf/subscribe [::sub/data :dealerships])
               form-state   state]
           [:div {}
            [:h1 {:class "customer__sub-heading"} "Add Gateway"]
            (let [superuser? (contains? (:roles @current-user) "superuser")]
              [:<>
               [:div {:style {:display         "flex"
                              :flex-direction  "row"
                              :justify-content "space-between"}}
                [:div
                 {:style {:flex-grow 1}}
                 (if openapi
                   [openapi/form
                    {:openapi          @openapi
                     :schema-name      "Asset"
                     :form-data        @form-state
                     :remap-properties {"dealership" (when superuser?
                                                       #(openapi/create-enum % @dealerships))}
                     :on-submit        (fn [data]
                                         (rf/dispatch
                                          [::events/put-data
                                           (str "/api/assets/" (:id data))
                                           (cond-> data
                                             true (assoc :customer (site/to-plain-id customer))
                                             true (assoc :site (site/to-plain-id site))
                                             true (assoc :dealership (:dealership customer)))
                                           [::events/modify-object-success "Added" :assets]])
                                         (reset! submitting? true))}
                    [:div {:style {:display         "flex"
                                   :justify-content "center"
                                   :paddingLeft     "20px"
                                   :paddingRight    "20px"
                                   :margin-top      "15px"
                                   :align-items     "center"
                                   :align-content   "center"}}
                     [:button
                      {:class "customer__cancel-button"
                       :type "button"
                       :on-click (fn []
                                   (rf/dispatch [::events/set-dialog :close]))}
                      [:span "Cancel"]]
                     [:button
                      {:class "customer__save-button"
                       :type :submit
                       :disabled @submitting?}
                      (if @submitting?
                        [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                        [:span "Save"])]]]
                   [:p "Loading..."])]]])])
         [:div {:style {:display         "flex"
                        :justify-content "center"
                        :paddingLeft     "40px"
                        :paddingRight    "40px"
                        :align-items     "center"
                        :align-content   "center"
                        :margin-top       "20px"}}]]])
     (when (= asset-dialog :edit-asset)
       [:div
        [:div.outside-modal
         {:on-click (fn []
                      (rf/dispatch [::events/set-dialog :close]))}]
        [:div
         {:style {:position        "fixed"
                  :top             "50%"
                  :left            "50%"
                  :border          "1px solid black"
                  :borderRadius    "5px"
                  :transform       "translate(-50%, -50%)"
                  :backgroundColor "white"
                  :zIndex          "100"
                  :padding         "20px"}}
         (let [state (r/atom nil)
               openapi      (rf/subscribe [::sub/data :openapi])
               current-user (rf/subscribe [::sub/current-user])
               dealerships  (rf/subscribe [::sub/data :dealerships])
               current-asset @(rf/subscribe [::sub/site-asset-tab])
               gateway      @(rf/subscribe [::sub/data :asset])
               form-state   state]
           [:div {}
            [:h1 {:class "customer__sub-heading"} "Edit Gateway"]
            (let [superuser? (contains? (:roles @current-user) "superuser")]
              [:<>
               [:div {:style {:display         "flex"
                              :flex-direction  "row"
                              :justify-content "space-between"}}
                [:div
                 {:style {:flex-grow 1}}
                 (if openapi
                   [openapi/form
                    {:openapi          @openapi
                     :schema-name      "Asset"
                     :form-data        @form-state
                     :remap-properties {"dealership" (when superuser?
                                                       #(openapi/create-enum % @dealerships))
                                        "name" (constantly {"title" "Name"
                                                            "type" "string"
                                                            "default" (:name gateway)})
                                        "ip" (constantly {"title" "IP Address"
                                                          "type" "string"
                                                          "default" (:ip gateway)})
                                        "id" (constantly {"title" "Gateway ID"
                                                          "type" "string"
                                                          "default" (:id gateway)})}
                     :on-submit        (fn [data]
                                         (rf/dispatch
                                          [::events/put-data
                                           (str "/api/assets/" (:id data))
                                           (cond-> data
                                             true (assoc :customer (site/to-plain-id customer))
                                             true (assoc :site (site/to-plain-id site))
                                             true (assoc :components (:components gateway))
                                             true (assoc :dealership (:dealership customer)))
                                           [::events/modify-object-success "Gateway Edited" :assets]])
                                         (reset! submitting? true))}
                    [:div {:style {:display         "flex"
                                   :justify-content "center"
                                   :paddingLeft     "20px"
                                   :paddingRight    "20px"
                                   :align-items     "center"
                                   :align-content   "center"
                                   :margin-top      "15px"}}
                     [:button
                      {:class "customer__cancel-button"
                       :type "button"
                       :on-click (fn []
                                   (rf/dispatch [::events/set-dialog :close]))}
                      [:span "Cancel"]]
                     [:button
                      {:class "customer__save-button"
                       :type :submit
                       :disabled @submitting?}
                      (if @submitting?
                        [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                        [:span "Save"])]]]
                   [:p "Loading..."])]]])])
         [:div {:style {:display         "flex"
                        :justify-content "center"
                        :paddingLeft     "40px"
                        :paddingRight    "40px"
                        :align-items     "center"
                        :align-content   "center"
                        :margin-top       "20px"}}]]])
     (when (= asset-dialog :iqube)
       [:div
        [:div.outside-modal
         {:on-click (fn []
                      (rf/dispatch [::events/set-dialog :close]))}]
        [:div
         {:style {:position        "fixed"
                  :top             "50%"
                  :left            "50%"
                  :border          "1px solid black"
                  :borderRadius    "5px"
                  :transform       "translate(-50%, -50%)"
                  :backgroundColor "white"
                  :zIndex          "100"
                  :padding         "20px"}}
         (let [state (r/atom nil)
               openapi      (rf/subscribe [::sub/data :openapi])
               current-user (rf/subscribe [::sub/current-user])
               dealerships  (rf/subscribe [::sub/data :dealerships])
               gateway      @(rf/subscribe [::sub/data :asset])
               form-state   state]
           [:div {}
            [:h1 {:class "customer__sub-heading"} "Add iQUBE"]
            (let [superuser? (contains? (:roles @current-user) "superuser")]
              [:<>
               [:div {:style {:display         "flex"
                              :flex-direction  "row"
                              :justify-content "space-between"}}
                [:div
                 {:style {:flex-grow 1}}
                 (if openapi
                   [openapi/form
                    {:openapi          @openapi
                     :schema-name      "iQube"
                     :form-data        @form-state
                     :remap-properties {"dealership" (when superuser?
                                                       #(openapi/create-enum % @dealerships))}
                     :on-submit        (fn [data]
                                         (rf/dispatch
                                          [::events/put-data
                                           (str "/api/iqubes/" (random-uuid))
                                           (cond-> data
                                             true (assoc :customer (site/to-plain-id customer))
                                             true (assoc :site (site/to-plain-id site))
                                             true (assoc :gateway (:id gateway))
                                             (nil? (:boards data)) (dissoc :boards)
                                             (nil? (:serial data)) (dissoc :serial)
                                             true (assoc :dealership (:dealership customer)))
                                           [::events/modify-object-success "Added" :iqubes]])
                                         (reset! submitting? true))}
                    [:div.dropdown-input
                     [:label "Gateway"]
                     [:input.form-control {:type "text"
                                           :disabled true
                                           :value (:name gateway)}]]
                    [:div {:style {:display         "flex"
                                   :justify-content "center"
                                   :paddingLeft     "20px"
                                   :paddingRight    "20px"
                                   :margin-top      "15px"
                                   :align-items     "center"
                                   :align-content   "center"}}
                     [:button
                      {:class "customer__cancel-button"
                       :type "button"
                       :on-click (fn []
                                   (rf/dispatch [::events/set-dialog :close]))}
                      [:span "Cancel"]]
                     [:button
                      {:class "customer__save-button"
                       :type :submit
                       :disabled @submitting?}
                      (if @submitting?
                        [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                        [:span "Save"])]]]
                   [:p "Loading..."])]]])])
         [:div {:style {:display         "flex"
                        :justify-content "center"
                        :paddingLeft     "40px"
                        :paddingRight    "40px"
                        :align-items     "center"
                        :align-content   "center"
                        :margin-top       "20px"}}]]])
     (when (= asset-dialog :scale)
       [:div
        [:div.outside-modal
         {:on-click (fn []
                      (rf/dispatch [::events/set-dialog :close]))}]
        [:div
         {:style {:position        "fixed"
                  :top             "50%"
                  :left            "50%"
                  :border          "1px solid black"
                  :borderRadius    "5px"
                  :transform       "translate(-50%, -50%)"
                  :backgroundColor "white"
                  :zIndex          "100"
                  :padding         "20px"}}
         (let [state (r/atom nil)
               openapi      (rf/subscribe [::sub/data :openapi])
               current-user (rf/subscribe [::sub/current-user])
               dealerships  (rf/subscribe [::sub/data :dealerships])
               iqube        @(rf/subscribe [::sub/data :iqube])
               gateway      @(rf/subscribe [::sub/data :asset])
               form-state   state]
           [:div {}
            [:h1 {:class "customer__sub-heading"} "Add Scale"]
            (let [superuser? (some #(= % "superuser") (:roles @current-user))
                  categories ["Truck Scale" "Floor Scale" "Bench Scale" "Tank Scale" "Other"]]
              [:<>
               [:div {:style {:display         "flex"
                              :flex-direction  "row"
                              :justify-content "space-between"}}
                [:div
                 {:style {:flex-grow 1}}
                 (if openapi
                   [openapi/form
                    {:openapi          @openapi
                     :schema-name      "Scale"
                     :form-data        @form-state
                     :remap-properties {"dealership" (when superuser?
                                                       #(openapi/create-enum % @dealerships))}
                     :on-submit        (fn [data]
                                         (rf/dispatch
                                          [::events/put-data
                                           (str "/api/scales/" (random-uuid))
                                           (cond-> data
                                             true (assoc :customer (site/to-plain-id customer))
                                             true (assoc :site (site/to-plain-id site))
                                             true (assoc :gateway (:id @(rf/subscribe [::sub/data :asset])))
                                             true (assoc :iqube (site/to-plain-id @(rf/subscribe [::sub/data :iqube])))
                                             true (assoc :category @(rf/subscribe [::sub/selected-scale-type]))
                                             (nil? (:load-cell data)) (dissoc :load-cell)
                                             (not superuser?) (assoc :dealership (:dealership customer))
                                             superuser? (assoc :dealership @(rf/subscribe [::sub/selected-scale-dealership])))
                                           [::events/modify-object-success "Added" :scales]])
                                         (reset! submitting? true))}
                    (when superuser?
                      [:div.dropdown-input
                       [:label "Dealership"]
                       [:select.form-control {:field :list :id :many.options
                                              :default-value (:dealership customer)
                                              :on-change (fn [evt]
                                                           (rf/dispatch [::events/set-selected-scale-dealership (-> evt .-target .-value)]))}
                        (rf/dispatch [::events/set-selected-scale-dealership (:dealership customer)])
                        (for [dealership @dealerships]
                          ^{:key (site/to-plain-id dealership)}
                          [:option {:value (site/to-plain-id dealership)} (:name dealership)])]])
                    [:div.dropdown-input
                     [:label "Scale Type"]
                     [:select.form-control {:field :list :id :many.options
                                            :on-change (fn [evt]
                                                         (rf/dispatch [::events/set-selected-scale-type (-> evt .-target .-value)]))}
                      [:option {:value "Other" :hidden true} "Select Scale Type"]
                      (for [category categories]
                        ^{:key category}
                        [:option {:value category} category])]]
                    [:div.dropdown-input
                     [:label "Gateway"]
                     [:input.form-control {:type "text"
                                           :disabled true
                                           :value (:name gateway)}]]
                    [:div.dropdown-input
                     [:label "iQUBE"]
                     [:input.form-control {:type "text"
                                           :disabled true
                                           :value (:name iqube)}]]
                    [:div {:style {:display         "flex"
                                   :justify-content "center"
                                   :paddingLeft     "20px"
                                   :paddingRight    "20px"
                                   :margin-top      "15px"
                                   :align-items     "center"
                                   :align-content   "center"}}
                     [:button
                      {:class "customer__cancel-button"
                       :type "button"
                       :on-click (fn []
                                   (rf/dispatch [::events/set-dialog :close]))}
                      [:span "Cancel"]]
                     [:button
                      {:class "customer__save-button"
                       :type :submit
                       :disabled @submitting?}
                      (if @submitting?
                        [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                        [:span "Save"])]]]
                   [:p "Loading..."])]]])])
         [:div {:style {:display         "flex"
                        :justify-content "center"
                        :paddingLeft     "40px"
                        :paddingRight    "40px"
                        :align-items     "center"
                        :align-content   "center"
                        :margin-top       "20px"}}]]])
     [:div {:style
            {:display "flex",
             :flex-direction "row"
             :margin-bottom "36px"}}
      [:button
       {:class "customer__header-button-selected"
        :type "button"
        :on-click (fn []
                    (rf/dispatch [::events/set-site-tab :site-assets]))}
       [:span "Assets"]]
      [:button
       {:class "customer__header-button"
        :type "button"
        :on-click (fn []
                    (rf/dispatch [::events/set-site-tab :site-details]))}
       [:span "Site Details"]]]
     [:div.asset-button-container
      [:button
       {:class "customer__add-button"
        :on-click (fn []
                    (rf/dispatch [::events/set-dialog :asset]))}
       [:span "+ Add Gateway"]]]
     [table/asset-table (assets/customer-asset-iqube-table assets)]]))

(defn site-details [customer site assets]
  (let [edit-site-dialog @(rf/subscribe [::sub/dialog])
        site @(rf/subscribe [::sub/data :site])]
   [:div
    [:div {:style
           {:display "flex",
            :flex-direction "row"
            :margin-bottom "20px"}}
     [:button
      {:class "customer__header-button"
       :type "button"
       :on-click (fn []
                   (rf/dispatch [::events/set-site-tab :site-assets]))}
      [:span "Assets"]]
     [:button
      {:class "customer__header-button-selected"
       :type "button"
       :on-click (fn []
                   (rf/dispatch [::events/set-site-tab :site-details]))}
      [:span "Site Details"]]]
    [:div.details-sidebar
     [:div.details-sidebar__container
      [:div.summary-details
       (for [{:keys [label value icon]}
             [{:label "Name"
               :value (:name site)
               :icon  "fa-building"}
              {:label "Contact"
               :value (:main-contact site)
               :icon  "fa-user"}
              {:label "Email"
               :value (:email site)
               :icon  "fa-at"}
              {:label "Location"
               :value (:location site)
               :icon  "fa-map-marked-alt"}
              {:label "Phone Number"
               :value (:phone site)
               :icon  "fa-phone"}]
             :when value]
         ^{:key (str label value)}
         [:div.summary-details__group
          (when-let [icon (get common/icons icon icon)]
            [:div.summary-details__icon
             [:i.fas {:class icon}]])
          [:div
           [:div.summary-details__label (str label)]
           [:div.summary-details__value (str value)]]])
       [:div {}
        (when (= edit-site-dialog :close)
          (reset! submitting? false))
        (when (= edit-site-dialog :edit-site)
          [:div
           [:div.outside-modal
            {:on-click (fn []
                         (rf/dispatch [::events/set-dialog :close]))}]
           [:div
            {:style {:position        "fixed"
                     :top             "50%"
                     :left            "50%"
                     :border          "1px solid black"
                     :borderRadius    "5px"
                     :transform       "translate(-50%, -50%)"
                     :backgroundColor "white"
                     :zIndex          "100"
                     :padding         "20px"}}
            (let [state (r/atom nil)
                  openapi      (rf/subscribe [::sub/data :openapi])
                  current-user (rf/subscribe [::sub/current-user])
                  dealerships  (rf/subscribe [::sub/data :dealerships])
                  form-state   state]
              [:div {}
               [:h1 {:class "customer__sub-heading"} "Edit Site"]
               (let [superuser? (contains? (:roles @current-user) "superuser")]
                 [:<>
                  [:div {:style {:display         "flex"
                                 :flex-direction  "row"
                                 :justify-content "space-between"}}
                   [:div
                    {:style {:flex-grow 1}}
                    (if openapi
                      [openapi/form
                       {:openapi          @openapi
                        :schema-name      "Site"
                        :form-data        @form-state
                        :remap-properties {"dealership" (when superuser?
                                                          #(openapi/create-enum % @dealerships))
                                           "name" (constantly {"title" "Name"
                                                               "type" "string"
                                                               "default" (:name site)})
                                           "location" (constantly {"title" "Location"
                                                                   "type" "string"
                                                                   "default" (:location site)})
                                           "email" (if (:email site) 
                                                     (constantly {"title" "Email"
                                                                "type" "string"
                                                                "format" "email"
                                                                "default" (:email site)})
                                                     (constantly {"title" "Email"
                                                                  "type" "string"
                                                                  "format" "email"}))
                                           "phone" (if (:phone site)
                                                     (constantly {"title" "Phone Number"
                                                                "type" "string"
                                                                "default" (:phone site)})
                                                     (constantly {"title" "Phone Number"
                                                                  "type" "string"}))
                                           "main-contact" (if (:main-contact site)
                                                            (constantly {"title" "Main Contact"
                                                                       "type" "string"
                                                                       "default" (:main-contact site)})
                                                            (constantly {"title" "Main Contact"
                                                                         "type" "string"}))}
                        :on-submit        (fn [data]
                                            (rf/dispatch
                                             [::events/put-data
                                              (str "/api/sites/" (site/to-plain-id site))
                                              (cond-> data
                                                true (assoc :customer (site/to-plain-id customer))
                                                true (assoc :dealership (:dealership customer))
                                                (nil? (:email data)) (dissoc :email)
                                                (nil? (:phone data)) (dissoc :phone)
                                                (nil? (:main-contact data)) (dissoc :main-contact))
                                              [::events/modify-object-success "Site Edited" :sites]])
                                            (reset! submitting? true)
                                            (rf/dispatch [:fetch/data [:site] (site/resource-path :sites (site/to-plain-id site))]))}
                       [:div {:style {:display         "flex"
                                      :justify-content "center"
                                      :paddingLeft     "20px"
                                      :paddingRight    "20px"
                                      :margin-top      "15px"
                                      :align-items     "center"
                                      :align-content   "center"}}
                        [:button
                         {:class "customer__cancel-button"
                          :type "button"
                          :on-click (fn []
                                      (rf/dispatch [::events/set-dialog :close]))}
                         [:span "Cancel"]]
                        [:button
                         {:class "customer__save-button"
                          :type :submit
                          :disabled @submitting?}
                         (if @submitting?
                           [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                           [:span "Save"])]]]
                       
                      [:p "Loading..."])]]])])
            [:div {:style {:display         "flex"
                           :justify-content "center"
                           :paddingLeft     "40px"
                           :paddingRight    "40px" 
                           :align-items     "center"
                           :align-content   "center"
                           :margin-top       "20px"}}]]])
        [:div {:on-click (fn []
                           (rf/dispatch [::events/set-dialog :edit-site]))}
         [:span.summary-details__edit-text "Edit Site"]]]]]]]))

(defn my-flatten [x]
  (if (coll? x)
    (mapcat my-flatten x)
    [x]))

(defn count-occurrences [s slist]
  (->> slist
       flatten
       (filter #{s})
       count))

(defn asset-counts []
  (let [live-assets @(rf/subscribe [::sub/live-assets])
        site @(rf/subscribe [::sub/data :site])
        assets @(rf/subscribe [::sub/site-assets (site/to-plain-id site)])
        iqubes @(rf/subscribe [::sub/site-iqubes (site/to-plain-id site)])
        scales @(rf/subscribe [::sub/site-scales (site/to-plain-id site)])]
    [:div.asset__counts
        [:div.asset__counts__inner
         [:span.counts__title "Gateways"]
         [:span.counts__count (count assets)]]
        [:div.asset__counts__inner
         [:span.counts__title "iQUBES"]
         [:span.counts__count (count iqubes)]]
        [:div.asset__counts__inner
         [:span.counts__title "Scales"]
         [:span.counts__count (count scales)]]
        [:div.asset__counts__alert
         [:span.alerts__title "Alerts"] 
         [:span.alerts__count
          (reduce (fn [sum gateway]
                    (+ sum (count (filterv #(or (> (count (:cells %)) 0) (> (count (:scale %)) 0))
                                            (take-nth 2 (rest (reduce into (filterv #(= (:id gateway)
                                                                                        (first (str/split (first %) #" "))) live-assets)))))))) 0 assets)]]]))

(defn one-site [k]
  (let [{:keys [path-params]} @(rf/subscribe [::sub/current-route])
        customer @(rf/subscribe [::sub/data :customer])
        site @(rf/subscribe [::sub/data :site])
        assets @(rf/subscribe [::sub/site-assets (site/to-plain-id site)])
        site-tabs @(rf/subscribe [::sub/site-tab])]
    (if (= (site/to-plain-id site) (:site path-params))
      [:div
       [asset-counts]
       [:h2.card__title (:name site)]
       (if (= site-tabs :site-assets)
         (site-asset customer site assets))
       (if (= site-tabs :site-details)
         (site-details customer site assets))]
     [:div.center
       [components/loader]])))
